<template>
  <div
    class="home-why-us-text-item"
    v-if="textItem"
  >
    <div class="row">
      <div class="col-2">
        <img
          :src="textItem.icon"
          alt=""
          width="55"
          class="mr-2"
        >
      </div>
      <div class="col-10">
        <h5 style="color: var(--primary);">
          <strong>{{ $t(textItem.title) }}</strong>
        </h5>
        <p>{{ $t(textItem.description ) }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeWhyUsTextItem',
  props: {
    textItem: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
  .home-why-us-text-item {
    margin-bottom: 20px;
  }

  @media (max-width: 1200px)  {
    .home-why-us-text-item {
      margin-bottom: 16px;
    }

    .home-why-us-text-item .col-10 p {
      margin: 0;
    }
  }
</style>
